import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

import Layout from '@/layouts/ModernTwoColumnsLayout.vue'
import { onMounted, onServerPrefetch, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useCategoriesStore } from '@/store/categories-store'
import Typography from '@/components_new/Typography.vue'
import ShopCards from '@/components_new/ShopCards/ShopCards.vue'
import { useUserStore } from '@/store/user-store/user-store'
import { useRewardsStore } from '@/store/rewards-store'
import { storeToRefs } from 'pinia'
import PromoSignInVertical from '@/components_new/PromoItems/components/PromoSignInVertical.vue'
import GoogleAuth from '@/components_new/GoogleAuth.vue'
import RewardsCards from '@/components_new/RewardsCards/RewardsCards.vue'
import { ROUTE_NAMES } from '@/router/constants'
import { useI18nAddon } from '@/i18n/i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'Shop',
  setup(__props) {

const categoriesStore = useCategoriesStore()

const userStore = useUserStore()
const { isAuthorized, user, isUserInfoLoaded } = storeToRefs(userStore)

const rewardsStore = useRewardsStore()
const router = useRouter()

const authCallback = async () => {
    const userData = await userStore.getUser()

    if (userData) {
        router.push({ name: ROUTE_NAMES.PROFILE })
    }
}

onServerPrefetch(async () => {
    await Promise.all([categoriesStore.setMainData(), rewardsStore.getRewards()])
})

onMounted(async () => {
    await Promise.all([categoriesStore.setMainData(), rewardsStore.getRewards()])
})

const { currentLocale } = useI18nAddon()
watch(currentLocale, categoriesStore.setMainData)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, null, {
    default: _withCtx(() => [
      _createElementVNode("main", {
        class: _normalizeClass(_ctx.$style.page)
      }, [
        (_unref(isUserInfoLoaded))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_unref(isAuthorized) && _unref(user))
                ? (_openBlock(), _createElementBlock("section", {
                    key: 0,
                    class: _normalizeClass(_ctx.$style.auth_title_page)
                  }, [
                    _createVNode(Typography, {
                      is: "h1",
                      type: "header",
                      size: "l"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$tr('rewards.title')), 1)
                      ]),
                      _: 1
                    })
                  ], 2))
                : (_openBlock(), _createElementBlock("section", {
                    key: 1,
                    class: _normalizeClass(_ctx.$style.non_auth_title_page)
                  }, [
                    _createVNode(Typography, {
                      is: "h2",
                      type: "header",
                      size: "l"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$tr('shop.page_title_non_auth')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(Typography, {
                      size: "m",
                      class: _normalizeClass(_ctx.$style.non_auth_description)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$tr('shop.page_description')), 1)
                      ]),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(GoogleAuth, { onFinish: authCallback })
                  ], 2))
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(RewardsCards, {
          rewards: _unref(rewardsStore).rewards,
          purchaseReward: _unref(rewardsStore).purchaseReward
        }, null, 8, ["rewards", "purchaseReward"]),
        _createVNode(PromoSignInVertical, {
          class: _normalizeClass(_ctx.$style.promo_mobile)
        }, null, 8, ["class"]),
        _createElementVNode("section", null, [
          _createVNode(Typography, {
            is: "h2",
            type: "header",
            size: "xs",
            class: _normalizeClass(_ctx.$style.section_title)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$tr('rewards.coming_soon')), 1)
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(ShopCards)
        ])
      ], 2)
    ]),
    _: 1
  }))
}
}

})